module.exports = __webpack_public_path__ + "static/media/icon-conservatory.a7164cc6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-conservatory.svg
// module id = 637
// module chunks = 0